import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import * as Constants from '../../helpers/constants'
import UserlistPage from '../user_list_page'
import TrialPeriods from '../trial_periods'
import MiscellaneousApi from '../miscellaneous'
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info'
import ProductList from '../products/component/list'
import CreateProduct from '../products/component/create'
import OrganizationInfo from '../org_info/org_info'
import Coupons from '../coupons/coupons'
import OrgListPage from '../org_list_page'
import ManageAbuse from '../abuse/manage_abuse'
import UpdateHistory from '../update_history/abuse_update_history'
import AbuseLogs from '../abuse_view_logs/abuse_view_logs'
import UserActivities from '../user_activities/user_activities'
import ServiceLists from '../service_list'
import MembersList from '../members_list/members_list'
import ProspectRequests from '../clearout_prospect_requests/myRequests'
import GeneratePurchaseURL from '../products/component/generate_url'
import SearchByTags from '../search_by_tags'
import ProspectSearch from '../prospect_search'
import PlanInfo from '../product_info/plan_info_card'



const CLIENT = Constants.CLIENTS.US_CLEAROUT.NAME

const clearoutRouter = createBrowserRouter([
  {
    id: 'dashboard-us_clearout-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-us_clearout-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-us_clearout-search-by-tags',
        path: 'search_by_tags',
        element: <SearchByTags />
      },
      {
        id: 'dashboard-us_clearout-ev-list',
        path: 'email_verifier_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_VERIFIER} />
      },
      {
        id: 'dashboard-us_clearout-ef-list',
        path: 'email_finder_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_FINDER} />
      },
      {
        id: 'dashboard-us_clearout-prospect-list',
        path: 'prospect_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.PROSPECT} />
      },
      {
        id: 'dashboard-us_clearout-org-members-list',
        path: 'org_members_list',
        element: <MembersList />
      },
      {
        id: 'dashboard-us_clearout-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'us_clearout-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'us_clearout-plan-list',
        path: 'plan_list',
        element: <ProductList />
      },
      {
        id: 'us_clearout-create-plan',
        path: 'create_plan',
        element: <CreateProduct />
      },
      {
        id: 'us_clearout-organization-info',
        path: 'organization_info',
        element: <OrganizationInfo />
      },
      {
        id: 'us_clearout_coupons',
        path: 'coupons',
        element: <Coupons />
      },
      {
        id: 'us_clearout_coupon',
        path: 'coupons/:couponId',
        element: <Coupons />
      },
      {
        id: 'dashboard-us_clearout-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'dashboard-us_clearout-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'dashboard-us_clearout-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: 'dashboard-us_clearout-org-users',
        path: 'org_list',
        element: <OrgListPage />
      },
      {
        id: 'dashboard-us_clearout-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'us_clearout_dashboard-prospect-requests',
        path: 'us_clearout_prospect/requests',
        element: <ProspectRequests />
      },

      {
        id: 'us_clearout-generate-purchase-url',
        path: 'generate_purchase_url',
        element: <GeneratePurchaseURL />
      },
      {
        id: 'us_clearout_dashboard-prospect-search',
        path: 'us_clearout_prospect/search',
        element: < ProspectSearch />
      },
      {
        id: 'us_clearout-plan-info',
        path: 'plan_info/:planId',
        element: <PlanInfo/>
      },
      {
        id: CLIENT + '-trial-periods',
        path: 'trial_periods',
        element: <TrialPeriods />
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },
    ]
  }
])

export default clearoutRouter
